export default "__VITE_ASSET__HYy0kII6__"